import type { Data } from "plotly.js";
import type { DatasetSizeWindow } from "src/store/api/generatedApi";

const BYTES_PER_GIB = 1024 ** 3;

export const buildCumulativeTraces = (windows: DatasetSizeWindow[]): Data[] => {
  const aggregated = new Map<
    string,
    { date: string; angle: string; sizeGib: number }
  >();
  for (const window of windows) {
    const key = `${window.date}\x00${window.angle}`;
    const existing = aggregated.get(key);
    if (existing) {
      existing.sizeGib += window.estimated_size_bytes / BYTES_PER_GIB;
    } else {
      aggregated.set(key, {
        date: window.date,
        angle: window.angle,
        sizeGib: window.estimated_size_bytes / BYTES_PER_GIB,
      });
    }
  }

  const byAngle = new Map<string, { dates: string[]; sizes: number[] }>();
  for (const { date, angle, sizeGib } of aggregated.values()) {
    const existing = byAngle.get(angle);
    if (existing) {
      existing.dates.push(date);
      existing.sizes.push(sizeGib);
    } else {
      byAngle.set(angle, { dates: [date], sizes: [sizeGib] });
    }
  }

  return [...byAngle.entries()].map(([angle, { dates, sizes }]) => {
    let runningTotal = 0;
    const cumulativeSizes = sizes.map((size) => (runningTotal += size));

    return {
      x: dates,
      y: cumulativeSizes,
      type: "scatter",
      mode: "lines",
      name: angle,
      stackgroup: "dataset",
    } satisfies Data;
  });
};
